import { render, staticRenderFns } from "./MyZs1.vue?vue&type=template&id=bee0c75e&scoped=true&"
import script from "./MyZs1.vue?vue&type=script&lang=js&"
export * from "./MyZs1.vue?vue&type=script&lang=js&"
import style0 from "./MyZs1.vue?vue&type=style&index=0&id=bee0c75e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee0c75e",
  null
  
)

export default component.exports